import React from 'react';
import ZsFormikTextField from "src/components/atoms/zsTextField";
import {validate} from "src/utils/yup";
import * as Yup from "yup";
import {getIn, useFormikContext} from "formik";

export interface IZipcodeProps {
    disabled? : boolean;
    authentication?: (customerNumber: string, zipcode: string) => void;
}

export function Zipcode(props: IZipcodeProps) {

    const { values } = useFormikContext();

    const customerNumber = getIn(values, 'customerNumber');

    const handleKeyDown = (event: any) => {
        if (event.target.value.length === 5 && customerNumber.length === 8) {
            if (props.authentication) {
                props.authentication(customerNumber, event.target.value);
            }
        }
    }

    return (
        <>
            <label><span style={{color: '#F00'}}>*</span> Postleitzahl des Vertragsinhabers</label>
            <ZsFormikTextField name="zc" inputProps={{maxLength: 5}}
                               type="onlyNumbers"
                               onChange={handleKeyDown}
                               disabled={props.disabled}
                               validate={validate(Yup.string().length(5, 'Ihre Postleitzahl muss aus 5 Ziffern bestehen.')
                                   .matches(/^[0-9]{5}$/, 'Bitte gültige Postleitzahl eingeben.')
                                   .required('Bitte die Postleitzahl eingeben.'))}
                               required/>
        </>
    );

}